module.exports = __webpack_public_path__ + "img/1f9ec.33b6a78.svg";